import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const Tabela = styled.div`
  background-color: var(--white);
  border-radius: 20px;
  tr{
    th{
      padding: 10px;
    }
    td{
      padding: 10px;
    }
  }
@media (max-width: 768px){
  table, thead, tbody, th, td, tr { 
    display: block; 
  }
  
  tr { 
    border-radius: 20px;
    margin-bottom: 1.5rem;
    box-shadow: 0 0 10px 0px var(--primary), 5px 5px 10px 0px #000;
    padding: 1rem;
  }

  tr:nth-child(1) {
    border: unset;
    box-shadow: unset;
    th {
      display: none;
      position: absolute;
      top: -9999px;
      left: -9999px;
    }
  } 
  
  td { 
    border: none;
    position: relative;
    padding-right: 50%;
  }
  
  td:before { 
    top: 6px;
    left: 6px;
    width: 45%; 
    padding-right: 10px; 
    white-space: nowrap;
  }
  td::before {
    font-weight: 700;
    font-style: italic;
  }
  
  td:nth-of-type(1):before { content: "Nome:"; }
  td:nth-of-type(2):before { content: "Email:"; }
  td:nth-of-type(3):before { content: "CPF:"; }
  td:nth-of-type(4) { text-align: right }
}
`;
export const Wrapper = styled.div`
  padding: 16px;
`;

export const ActionContainer = styled.td`
  display: flex;
`;

export const Premmiar = styled.button`
  display: inline-flex;
  background-color: var(--success);
  color: var(--white);
  padding: 8px;
  border-radius: 4px;
  aspect-ratio: 1;
  width: 32px;
  font-size: 14px;
  justify-content: center;
  align-items: center;
  margin-right: 8px;

  &:hover {
    color: var(--white);
  }
`;

export const Edit = styled(Link)`
  display: inline-flex;
  background-color: var(--secondary);
  color: var(--white);
  padding: 8px;
  border-radius: 4px;
  aspect-ratio: 1;
  width: 32px;
  font-size: 14px;
  justify-content: center;
  align-items: center;
  margin-right: 8px;

  &:hover {
    color: var(--white);
  }
`;

export const Exclude = styled.button`
  display: inline-flex;
  background-color: var(--danger);
  color: var(--white);
  padding: 8px;
  border-radius: 4px;
  aspect-ratio: 1;
  width: 32px;
  font-size: 14px;
  justify-content: center;
  align-items: center;

  &:hover {
    color: var(--white);
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  & > div {
    flex: 1;
    margin-right: 16px;
  }
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    .form-input {
      margin-right: 0;
      width: 100%;
      max-width: 30rem;
      margin-bottom: 1rem;
    }
  }
`;

export const LinkButton = styled.button.attrs(() => {
  return {
    className: 'button'
  };
})`
  min-width: 168px;
  width: 300px;
  margin-top: 0;
  float: right;
  background-color: var(--secondary);
  box-shadow: 4px 7px 12px 0 rgba(35,210,226,.2);
  display: block;
  height: 48px;
  border-radius: 10px;
  color: var(--white);
  font-size: .875rem;
  font-weight: 700;
  text-align: center;
  line-height: 48px;
  cursor: pointer;
  transition: background-color .2s ease-in-out,color .2s ease-in-out,border-color .2s ease-in-out,box-shadow .2s ease-in-out;
  box-shadow: 3px 5px 10px 0 rgba(62,63,94,.2);
  /* Fix position at admin/usuarios */
  justify-self: end;

  &:hover {
    background-color: var(--hover);
  }
`;
